import { render, staticRenderFns } from "./editCalloutCards.vue?vue&type=template&id=7020ee9a"
import script from "./editCalloutCards.vue?vue&type=script&lang=js"
export * from "./editCalloutCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports